import * as React from "react";
import { Switch } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import RunbookRunToRunbookTaskRedirect from "./RunbookRunToRunbookTaskRedirect";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";
import routeLinks from "../../routeLinks";

export default class RunbookRunRoutes extends React.Component<RouteComponentProps> {
    render() {
        return (
            <Switch>
                <ReloadableRoute path={routeLinks.runbookRun(":runbookRunId").root} component={RunbookRunToRunbookTaskRedirect} />
            </Switch>
        );
    }
}
